import { render, staticRenderFns } from "./FoodpandaMenuManagement.vue?vue&type=template&id=eda1e846&scoped=true&"
import script from "./FoodpandaMenuManagement.vue?vue&type=script&lang=js&"
export * from "./FoodpandaMenuManagement.vue?vue&type=script&lang=js&"
import style0 from "./FoodpandaMenuManagement.vue?vue&type=style&index=0&id=eda1e846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda1e846",
  null
  
)

export default component.exports